import type { Platform } from "../../shared/prompts/templates";

// Platform marks are Font Awesome Brands, never recoloured. Goal and prompt icons live in
// templates.ts and render as inline duotone SVG through shared/prompts/duotone.ts.
export const PLATFORM_ICONS: Record<Platform, string> = {
  instagram: "fa-brands fa-instagram",
  linkedin: "fa-brands fa-linkedin",
  tiktok: "fa-brands fa-tiktok",
  facebook: "fa-brands fa-facebook",
  "youtube-shorts": "fa-brands fa-youtube",
};
